import { Suspense, lazy } from 'react';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const RequestAnalytics = Loader(
  lazy(() => import('src/content/pages/Application/RequestAnalytics'))
);

const requestAnalyticsRoutes = [
  {
    path: '/',
    element: <RequestAnalytics />
  }
];

export default requestAnalyticsRoutes;
